import React from "react";

import { Typography } from "Components/atoms/Typography";
import { StopsTextProps } from "./types";

import { getStopColor } from "shared/config/results/colorConfig";

/**
 * Componente StopsText
 *
 * Exibe o número de paradas em um voo, formatado dinamicamente com cores.
 *
 * @param {number} stops - Número de paradas no voo.
 */
export const StopsText: React.FC<StopsTextProps> = ({ stops }) => {
  const color = getStopColor(stops);
  const stopsText =
    stops === 0 ? "Direto" : `${stops} parada${stops > 1 ? "s" : ""}`;

  return (
    <Typography as="span" variant="caption" color={color} align="center">
      {stopsText}
    </Typography>
  );
};
